var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg43(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Normal",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "722.07px",
    height: "722.068px",
    viewBox: "0 0 722.07 722.068",
    enableBackground: "new 0 0 722.07 722.068",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#009FDB",
    d: "M0,361.033l361.034,361.035L722.07,361.036L361.034,0L0,361.033z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M361.035,682.049L682.05,361.036L361.035,40.021L40.019,361.033L361.035,682.049z M361.035,54.162 c6.832,6.834,300.039,300.039,306.872,306.874c-6.833,6.833-300.04,300.036-306.872,306.87 c-6.834-6.834-300.039-300.037-306.873-306.873C60.996,354.201,354.201,60.996,361.035,54.162z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M383.347,543.609h-10.629l-28.62,38.167v10.084h27v12.124h12.249V591.86h8.251v-10.125h-8.251V543.609z  M371.098,581.735h-15.167l15.167-20.434V581.735z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M360.887,84.228c-14.703,28.083,3.212,43.936-16.538,85.305c-10.479-8.373-4.404-39.661-25.215-40.185 c3.203,9.608,0.806,13.34,0.271,16.81c-2.07,13.456-6.874,25.481,2.467,43.363c-14.35-6.972-14.588-19.764-26.721-27.787 c2.402,13.612-3.382,41.213,12.733,67.659c-14.36-1.412-19.123-6.934-34.666-21.828c16.221,84.03,28.289,86.391,87.772,91.158 c-4.482-0.524-34.453-5.312-45.308-39.85c-0.616-8.552-0.955,7.516,27.87,8.049c-18.251-28.905-13.279-23.434-11.144-40.247 c7.556,11.507,0.937,12.513,22.288,21.054c-6.77-21.508,10.447-36.226,6.712-60.779c4.718,10.783,21.499,9.085,20.699,60.862 c13.895-15.501,15.553-4.771,22.225-22.12c0.387,9.658,4.626,21.685-14.26,41.481c4.804,1.335,12.848,2.369,25.926-6.439 c-12.733,14.432-1.225,14.771-33.432,38.388c40.568,0.533,67.213-25.004,66.258-81.124c-1.067,4.805-2.264,14.396-24.148,17.333 c13.709-13.622,20.853-40.744,9.91-63.163c-3.853,3.583-9.841,20.244-24.253,25.048c7.31-11.994,5.665-27.515,5.665-27.515 s1.866-20.964-10.517-37.154c-3.47,25.355-3.18,38.105-19.192,42.109c2.576-14.965,3.051-21.933-4.956-39.015 C372.973,117.8,363.288,100.242,360.887,84.228z M293.897,313.213v7.339v7.359h71.401h71.4l-0.021-7.339l-0.021-7.318l-71.359-0.021 L293.897,313.213z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg43);
export default __webpack_public_path__ + "static/media/4.3.8a3f00e196c1b8c18b0bd96578f0ac27.svg";
export { ForwardRef as ReactComponent };